module.exports = __webpack_public_path__ + "static/media/BrownPurleHaze.502ae112.jpg";